<div class="spinner" *ngIf="!dataLoaded"></div>
<ng-container *ngIf="dataLoaded">
    <form *ngIf="isRegistrationSearchApplicable">
        <ng-container *ngIf="!registration">
            <h2>Registrations</h2>
            <table *ngIf="registrations" class="mvd_table--primeng">
                <thead>
                    <tr>
                        <th>Owner Name</th>
                        <th class="w--vin">VIN</th>
                        <th>Year</th>
                        <th>Make</th>
                        <th>Model</th>
                        <th>Plate</th>
                        <th>Expiration Date</th>
                        <th>Reg Status</th>
                        <th>Select</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let r of registrations">
                        <td>{{r.customerName}}</td>
                        <td>{{r.vehicleOwnershipPlate.vehicleOwnership.vehicle.vin}}</td>
                        <td>{{r.vehicleOwnershipPlate.vehicleOwnership.vehicle.modelYear}}</td>
                        <td>{{r.vehicleOwnershipPlate.vehicleOwnership.vehicle.makeDisplayValue}}</td>
                        <td>{{r.vehicleOwnershipPlate.vehicleOwnership.vehicle.modelDisplayValue}}</td>
                        <td>{{r.vehicleOwnershipPlate.plate.plateNumber}}</td>
                        <td>
                            <ng-container *ngIf="r.registrationEndDate">{{r.registrationEndDate | shortDate}}</ng-container>
                            <ng-container *ngIf="r.vehicleOwnershipPlate.vehicleOwnership.vehicle.permanentRegistrationDate">Permanent</ng-container>
                        </td>
                        <td>{{r.registrationStatusTypeID | displayValue:registrationStatusTypes}}</td>
                        <td class="w--icon">
                            <a class="icon--select" title="Select" href="javascript:void(0);" (click)="onRegistrationSelected(r)"></a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </ng-container>

        <ng-container *ngIf="registration">
            <h2>Registration Details <button class="icon--remove btn--default" type="button" title="Remove" (click)="onRemoveRegistration()" [ngClass]="{hidden: readOnly}">Remove</button></h2>
            <fieldset>
                <div class="row">
                    <div class="col-sm-3 mvd_form-group">
                        <label>Registration Number</label>
                        <input class="mvd_form-control" disabled="" type="text" value="{{registration.id}}">
                    </div>
                    <div class="col-sm-2 mvd_form-group">
                        <label>First Registered</label>
                        <input class="mvd_form-control" disabled="" type="text" value="{{registration.vehicleOwnershipPlate.vehicleOwnership.vehicle.monthFirstRegistered | number:'2.0-0'}}/{{registration.vehicleOwnershipPlate.vehicleOwnership.vehicle.yearFirstRegistered}}">
                    </div>

                    <div class="col-sm-2 mvd_form-group">
                        <label>Expires</label>
                        <input class="mvd_form-control" disabled="" type="text" value="{{registration.registrationEndDate | shortDate}}">
                    </div>
                    <div class="col-sm-2 mvd_form-group">
                        <label>Use</label>
                        <input class="mvd_form-control" disabled="" type="text" value="{{registration.registrationUseTypeID | displayValue:registrationUseTypes}}">
                    </div>

                    <div class="col-sm-3 mvd_form-group">
                        <label>Registration Type</label>
                        <input class="mvd_form-control" disabled="" type="text" value="{{registration.registrationTypeID | displayValue:registrationTypes}}">
                    </div>
                </div>
            </fieldset>
        </ng-container>

        <div class="spinner" *ngIf="!isResultsLoaded"></div>
        <p class="mvd_alert--label" *ngIf="isResultsLoaded &&(!registrations || !registrations.length)">No registration found. Modify your search criteria.</p>
    </form>

    <form *ngIf="isPermitSearchApplicable">

        <ng-container *ngIf="!vehiclePermit">
            <h2>Permits</h2>
            <table class="mvd_table--primeng">
                <thead>
                    <tr>
                        <th class="w--icon">Permit #</th>
                        <th>Permit Type</th>
                        <th>Customer Name</th>
                        <th class="w--vin">Vin</th>
                        <th class="w--icon">Select</th>
                    </tr>
                </thead>
                <tbody *ngIf="vehiclePermits && vehiclePermits.length">
                    <tr *ngFor="let p of vehiclePermits">
                        <td>{{p.permitNumber}}</td>
                        <td>{{p.vehiclePermitTypeId | displayValue:permitTypes}}</td>
                        <td>{{p.customer.customerName}}</td>
                        <td>{{p.vehicle.vin}}</td>
                        <td>
                            <a class="icon--select" title="Select" href="javascript:void(0);" (click)="onPermitSelected(p)"></a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </ng-container>

        <ng-container *ngIf="vehiclePermit">
            <h2>Permit Details <button class="icon--remove btn--default" type="button" title="Remove" (click)="onRemovePermit()" [ngClass]="{hidden: readOnly}">Remove</button></h2>
            <fieldset>
                <div class="row">
                    <div class="col-sm-2 mvd_form-group">
                        <label>Permit Number</label>
                        <input class="mvd_form-control" disabled="" type="text" value="{{vehiclePermit.permitNumber}}">
                    </div>
                    <div class="col-sm-2 mvd_form-group">
                        <label>Type</label>
                        <input class="mvd_form-control" disabled="" type="text" value="{{vehiclePermit.vehiclePermitTypeId | displayValue:permitTypes}}">
                    </div>

                    <div class="col-sm-3 mvd_form-group">
                        <label>Issued</label>
                        <input class="mvd_form-control" disabled="" type="text" value="{{vehiclePermit.issueDate | shortDate}}">
                    </div>
                    <div class="col-sm-3 mvd_form-group">
                        <label>Expires</label>
                        <input class="mvd_form-control" disabled="" type="text" value="{{vehiclePermit.expirationDate | shortDate}}">
                    </div>
                </div>
            </fieldset>
        </ng-container>

        <div class="spinner" *ngIf="!isResultsLoaded"></div>
        <p class="mvd_alert--label" *ngIf="isResultsLoaded && (!vehiclePermits || !vehiclePermits.length)">No permit found. Modify your search criteria.</p>
    </form>

    <form *ngIf="isPlacardSearchApplicable">
        <ng-container *ngIf="!placard">
            <h2>Placard Results</h2>
            <table class="mvd_table--primeng">
                <thead>
                    <tr>
                        <th>Placard Type</th>
                        <th>Placard #</th>
                        <th>Issue Date</th>
                        <th>Expiration Date</th>
                        <th>One-Time Mailing</th>
                        <th>Select</th>
                    </tr>
                </thead>
                <tbody *ngIf="placards && placards.length">
                    <tr *ngFor="let p of placards">
                        <td>{{getPlacardType(p.plate.plateConfigurationId)}}</td>
                        <td>{{p.plate.plateNumber}}</td>
                        <td>{{p.issueDate | shortDate}}</td>
                        <td>{{p.expiredDate | shortDate}}</td>
                        <td>
                            <ng-container *ngIf="p.onetimeMailingAddress">{{p.onetimeMailingAddress.addressLine1}}
                                <ng-container *ngIf="p.onetimeMailingAddress.addressLine2">{{p.onetimeMailingAddress.addressLine2}}</ng-container>
                                {{p.onetimeMailingAddress.city}}, {{p.onetimeMailingAddress.jurisdictionId | displayValue:jurisdictions}}, {{p.onetimeMailingAddress.postalZipCode}}
                            </ng-container>
                        </td>
                        <td class="w--icon">
                            <a class="icon--select" title="Select" href="javascript:void(0)" data-bs-toggle="tooltip" (click)="onPlacardSelected(p)"></a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </ng-container>

        <ng-container *ngIf="placard">
            <h2>Placard Details <button class="icon--remove btn--default" type="button" title="Remove" (click)="onRemovePlacard()" [ngClass]="{hidden: readOnly}">Remove</button></h2>
            <fieldset>
                <div class="row">
                    <div class="col-sm-2 mvd_form-group">
                        <label>Placard Type</label>
                        <input class="mvd_form-control" disabled="" type="text" value="{{getPlacardType(placard.plate.plateConfigurationId)}}">
                    </div>
                    <div class="col-sm-2 mvd_form-group">
                        <label>Placard #</label>
                        <input class="mvd_form-control" disabled="" type="text" value="{{placard.plate.plateNumber}}">
                    </div>

                    <div class="col-sm-3 mvd_form-group">
                        <label>Issue Date</label>
                        <input class="mvd_form-control" disabled="" type="text" value="{{placard.issueDate | shortDate}}">
                    </div>
                    <div class="col-sm-3 mvd_form-group">
                        <label>Expiration Date</label>
                        <input class="mvd_form-control" disabled="" type="text" value="{{placard.expiredDate | shortDate}}">
                    </div>
                </div>
            </fieldset>
        </ng-container>

        <div class="spinner" *ngIf="!isResultsLoaded"></div>
        <p class="mvd_alert--label" *ngIf="isResultsLoaded && (!placards || !placards.length)"><b>No placards found. Modify your search criteria.</b></p>
    </form>
</ng-container>
